/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticlePaywall/theme';

export const ArticlePaywallTheme = theme;
